import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '—';
  try {
    let date;
    if (typeof dateString === 'string') {
      // Handle DD/MM/YYYY HH:MM format (from port scrapers)
      const ddmmMatch = dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?/);
      if (ddmmMatch) {
        const [, day, month, year, hour, min] = ddmmMatch;
        date = new Date(year, month - 1, day, hour || 12, min || 0);
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        // Date-only format: add noon time to avoid day shift
        date = new Date(dateString + 'T12:00:00');
      } else {
        date = new Date(dateString);
      }
    } else {
      date = new Date(dateString);
    }
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return dateString;
  }
}

export function formatDateTime(dateString) {
  if (!dateString) return '—';
  try {
    let date;
    if (typeof dateString === 'string') {
      // Handle DD/MM/YYYY HH:MM format (from port scrapers)
      const ddmmMatch = dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:\s+(\d{2}):(\d{2}))?/);
      if (ddmmMatch) {
        const [, day, month, year, hour, min] = ddmmMatch;
        date = new Date(year, month - 1, day, hour || 0, min || 0);
      } else {
        date = new Date(dateString);
      }
    } else {
      date = new Date(dateString);
    }
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('es-MX', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch {
    return dateString;
  }
}

export function formatCurrency(amount, currency = 'USD') {
  if (amount === null || amount === undefined) return '—';
  return new Intl.NumberFormat('es-MX', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
